// extracted by mini-css-extract-plugin
export default {"container":"video-block_container__3Kc9d","shape":"video-block_shape__syaqd","video":"video-block_video__1osF3","vertical":"video-block_vertical__1pE84"};